module.exports = __webpack_public_path__ + "media/images/icon_checkbox_off_38-37-a3adf9db6e61feb0933ee3d8b328d8a1.png";